export const FORM = {
  header: "CLINICA PRIME",
  header2: "MEDICAL CENTER",
  headerColumns: [
    {
      doc1: "Amount Grace Hospital",
      value: [
        "J.T. Kangleon St. Ormoc City, Leyte, Philippines 6541",
        "(053) 561 - 7937 | info@gatchalianmedicalcenter.com",
      ],
    },
  ],
  footer: {
    doctor_name: "MYT ADMIN",
    prc_no: "PRC No. 111111",
  },
};
